export default {
    retry: 0,
};
